import React, {useEffect, useState} from 'react'
import { CgArrowLeft } from 'react-icons/cg'
import icon1 from "../../../../../assets/jobIcons/icon1.svg"
import "react-quill/dist/quill.snow.css"
import axios from "axios"
import {Link, useParams} from "react-router-dom"
import "react-loading-skeleton/dist/skeleton.css"
import { formatDateTime, formatSalary } from '../../../../../../components/DateTimeConverter/DateTimeConverter'
import { FaCalendarAlt, FaChalkboard, FaChalkboardTeacher, FaHourglassHalf, FaMoneyBillWave, FaRegCalendarCheck } from 'react-icons/fa'

const About = ({item}) => {
    const { id } = useParams(); // Récupérer l'id du job à partir de l'URL
      const icons = {
        "Type de cours": <FaChalkboardTeacher className="text-2xl text-primary" />,
        "Durée": <FaHourglassHalf className="text-2xl text-primary" />,
        "Tarif": <FaMoneyBillWave className="text-2xl text-primary" />,
        "Date de début": <FaCalendarAlt className="text-2xl text-primary" />,
        "Date de fin": <FaRegCalendarCheck className="text-2xl text-primary" />,
      };


  return (
    <div className=''>
        <div className=" flex justify-between  gap-10 text-sm">
      
           <div className="w-full lg:w-2/3 text-justify space-y-6">
           <div>
             <h4 className="text-xl font-bold mb-2">A propos du centre</h4>
             <p>{item?.user?.description || "Aucune description disponible."}</p>
           </div>
           <div>
             <h4 className="text-xl font-bold mb-2">Prérequis</h4>
             <p>{item?.required_profile || "Aucun."}</p>
           </div>
           <div>
             <h4 className="text-xl font-bold mb-2">Objectifs de la item</h4>
             <p>{item?.objective || "Objectifs non spécifiés."}</p>
           </div>
           <div>
             <h4 className="text-xl font-bold mb-2">Programme</h4>
             <p>{item?.description || "Programme non disponible."}</p>
           </div>
         </div>
     
             <div className="w-1/3  bg-white  sticky top-20">
             <div className="border-gray-300 rounded-2xl border-2">
               <h5 className="text-xl font-semibold py-4 text-start px-6">Information générale</h5>
     
     
               {[
             { label: "Type de cours", value: item?.type },
             { label: "Durée", value: item?.duration },
             // { label: "Droit", value: formatSalary(item?.fees) },
             { label: "Tarif", value: formatSalary(item?.fees) },
             { label: "Date de début", value: formatDateTime(item?.training_start_at) },
             { label: "Date de fin", value: formatDateTime(item?.training_end_at) },
           ].map(({ label, value }) => (
             <div key={label} className="border-b flex gap-4 items-center py-4 mx-6">
             {icons[label] || <FaChalkboard className="text-3xl text-primary" />}
             <div className="flex justify-between flex-col text-start">
               <div className='text-sm text-primary-text'>{label}</div>
               <div className='font-semibold'>{value || "Non spécifié"}</div>
             </div>
           </div>  
           ))}
             </div>
              
             </div>
     </div>

    </div>
  )
}

export default About